import React from 'react';
import { Link } from 'react-router-dom';

export const HeaderContainer = (props) => {
  let className = "header";
  if (props.show) className += " active"

  return <div className={className}>
    <div className="header-logo">
        <Link to="/">
          <img alt="logo" src="./images/logo.png" />
        </Link>
    </div>
    <div className="header-menu">
        <Link to="/">Projects</Link>
        <Link to="/cv">CV</Link>
    </div>
  </div>
};


// WEBPACK FOOTER //
// ./src/components/HeaderContainer.js